@if (!hideLabel) {
  <div
    class="sv__label"
    [class.sv__label-empty]="!label"
    [class.sv__label-width]="labelWidth !== null && labelWidth !== undefined"
    [class.sv__no-colon]="_noColon"
    [style.width.px]="labelWidth"
  >
    <span class="sv__label-text">
      <ng-container *nzStringTemplateOutlet="label">{{ label }}</ng-container>
    </span>
    @if (optional || optionalHelp) {
      <span class="sv__label-optional" [class.sv__label-optional-no-text]="!optional">
        <ng-container *nzStringTemplateOutlet="optional">{{ optional }}</ng-container>
        @if (optionalHelp) {
          <nz-icon
            nz-tooltip
            [nzTooltipTitle]="optionalHelp"
            [nzTooltipColor]="optionalHelpColor"
            nzType="question-circle"
          />
        }
      </span>
    }
  </div>
}
<div class="sv__detail">
  <span (cdkObserveContent)="checkContent()" #conEl>
    <ng-content />
  </span>
  @if (!!unit) {
    <span class="sv__unit" *nzStringTemplateOutlet="unit">{{ unit }}</span>
  }
</div>
